import React, {useRef, useState, useEffect} from 'react';
import TabPanel from "devextreme-react/tab-panel";
import Guid from '../../models/Guid';
import ITypeUnite from "../../models/ITypeUnite";
import {useStorage} from '../../hooks/useStorage';
import useApi from "../../hooks/useApi";
import ITypeUniteGroupe from "../../models/ITypeUniteGroupe";
import {TypeTabCalendrier, ITypeUniteTabs} from './calendrier-interfaces';

interface CalendrierTabsProps {
    onSelectionChange: any
}

const CalendrierTabs = ({onSelectionChange}: CalendrierTabsProps) => {
    const tabRef = useRef<any>(null);
    const [typeUniteTabs, setTypeUniteTabs] = useState<ITypeUniteTabs[]>([]);
    const [selectedTabIndex, setSelectedTabIndex] = useStorage<number>({storageType: "localStorage", key: "calendrier.selectedTabIndex", defaultValue: 0});
    const {data: typeUnites, getData: getTypeUnites} = useApi<ITypeUnite[]>("typeunite/list");
    const {data: typeUnitesGroupe, getData: getTypeUnitesGroupe} = useApi<ITypeUniteGroupe[]>("typeunitegroupe");

    useEffect(() => {
        getTypeUnites();
        getTypeUnitesGroupe();
    }, [])

    useEffect(() => {
        const type: ITypeUniteTabs[] = (typeUnites || []).filter(f => f.idTypeUnite?.toString() !== Guid.empty.toString()).sort((a, b) => (a.ordreAffichage - b.ordreAffichage)).map(type => {
            return {type: TypeTabCalendrier.TypeUnite, id: type.idTypeUnite, description: type.description, typePeriode: type.typePeriode, nombreColonnes: type.nombreColonnes, tailleColonne: `${type.tailleColonne}px`, calDateDebut: type.calDateDebut, calDateFin: type.calDateFin, dureePeriode: type.dureePeriode} as ITypeUniteTabs
        });
        const categorie: ITypeUniteTabs[] = (typeUnitesGroupe || []).filter(f => f.idTypeUniteGroupe?.toString() !== Guid.empty.toString()).map(type => {
            return {type: TypeTabCalendrier.GroupeTypeUnite, id: type.idTypeUniteGroupe, description: type.description, typePeriode: type.typePeriode, nombreColonnes: type.nombreColonnes, calDateDebut: type.calDateDebut, calDateFin: type.calDateFin, dureePeriode: type.dureePeriode} as ITypeUniteTabs
        });
        setTypeUniteTabs([...categorie, ...[{type: TypeTabCalendrier.Carte, id: Guid.max, typePeriode: -1, description: "carte", nombreColonnes: 0, tailleColonne: "0", calDateDebut: new Date(), calDateFin: new Date()}], ...type]);
    }, [typeUnites, typeUnitesGroupe])

    return (
        <>
            <TabPanel
                ref={tabRef}
                dataSource={typeUniteTabs}
                selectedIndex={selectedTabIndex || 0}
                showNavButtons scrollingEnabled={true}
                onSelectedIndexChange={(ind: any) => {
                    setSelectedTabIndex(ind);
                }}
                onSelectedItemChange={onSelectionChange}
                itemTitleRender={(typeUnite: ITypeUnite) => typeUnite.description}
            />
        </>
    )
}
export default CalendrierTabs;